/* unplugin-vue-components disabled */import script from "./XDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./XDialog.vue?vue&type=script&setup=true&lang=ts"

import "./XDialog.vue?vue&type=style&index=0&id=90a4d2d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90a4d2d0"]])

export default __exports__